export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 .002c1.712 0 3.424-.009 5.137.01C6.776.03 8.61.055 10.206.657c1.722.65 2.863 1.786 4.01 3.124.827.962 2.45 3.015 3.24 4.006.647.812 1.913 2.418 2.605 3.195.87.978 1.945 2.017 3.44 2.017 1.494 0 2.569-1.04 3.438-2.016.692-.776 1.958-2.383 2.605-3.195.79-.991 2.412-3.044 3.24-4.006 1.149-1.337 2.288-2.474 4.01-3.124 1.596-.6 3.43-.627 5.069-.645 1.712-.019 3.425-.01 5.137-.01\" fill=\"#fff\"/>",
  "attrs": {
    "width": "47",
    "height": "13",
    "viewBox": "0 0 47 13",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};